(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-recommendations"] && !Shopify.designMode) return;
  try {
    class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      
      const handleIntersection = (entries, observer) => {
        if( entries[0].isIntersecting ) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if(recommendations && recommendations.innerHTML.trim().length){
              this.innerHTML = recommendations.innerHTML;
            }

          })
          .catch(error => {
            console.error('Error fetching product recommendations:', error);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);
  } catch(e) { console.error(e); }
})();

})();
